<title>Hy Cite - Error 404</title>
<meta name="description" content="HyCite error 404" />

<ng-container *transloco="let t; read: 'pages.not-found'">
  <div class="inner-page">
    <div class="content basic-content-with-subtitle">
      <div class="content-group left">
        <app-img-with-backdrop
          backdropColor="slate"
          backdropPos="bottom-left"
          shape="square"
          src="/assets/not-found-page-cover.jpg"></app-img-with-backdrop>
      </div>

      <div class="content-group right">
        <div [innerHTML]='t("title")' class="h2 title"></div>
        <p [innerHTML]='t("subtitle")' class="subtitle"></p>
        <app-button [buttonText]='t("button")' href="/" mode="dark" size="big" type="outline"></app-button>
      </div>
    </div>
  </div>
</ng-container>
